import React from 'react'
import ReactPlayer from 'react-player'
import sonnenIntro from '../assets/sonnen.mp4'
import sonnenSound from '../assets/sonnen.aac'

class Intro extends React.Component {

  constructor(props) {
    super(props)
    
    this.handleVideoFadeout = this.handleVideoFadeout.bind(this)
    this.handleVideoEnd = this.handleVideoEnd.bind(this)
    this.handleAudio = this.handleAudio.bind(this)
  }
    
  handleVideoFadeout (event) {
    setTimeout(function() { 
      if (document.getElementById('videoFade')) {
        document.getElementById('videoFade').style.opacity = 0
      }
    }.bind(this), 6000);
  }
    
  handleVideoEnd (event) {
    let el = document.getElementById('videoFade')
    el.parentNode.removeChild(el)
    // el.style.display = 'none'
  }
    
  handleAudio (event) {
    this.introAudio.player.player.autoplay = true
    // console.log(this.introAudio)
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return (
	  <div className="Intro-Container" id="videoFade">
       <ReactPlayer 
          url={sonnenIntro}
          className="Intro-Video"
          width="100%" 
          height="auto" 
          playing
          playsinline
          //fileConfig={{ attributes: { autoPlay:true }}}
          onReady={this.handleVideoFadeout}
          onEnded={this.handleVideoEnd}
          ref={(introVideo) => {this.introVideo = introVideo}}
        />
        <ReactPlayer
          url={sonnenSound}
          className="Intro-Sound"
          playing
          playsinline
          volume={1.0}
          hidden={true}
          onReady={this.handleAudio}
          ref={(introAudio) => {this.introAudio = introAudio}}
        />
	  </div>
    )
  }
}

export default Intro


// WEBPACK FOOTER //
// ./src/components/Intro.js